import React from "react";
import { useSelector } from "react-redux";
import { LoadingState, PageHeader } from "@KristianIV/common-ui";
import PageLayout from "../shell/PageLayout";
import { ApplicationState } from "../reducers";
import GlobalSearch from "./GlobalSearch";
import OrganisationActivity from "./OrganisationActivity";
import RoundsTable from "./RoundsTable";
import ToolCards from "./ToolCards";

/** The landing page: gunshot activity per organisation, the other admin pages and tools, and the round analyzer. */
const Dashboard = () => {
  const jwtToken = useSelector((state: ApplicationState) => state.login.jwtToken);
  const userData = useSelector((state: ApplicationState) => state.login.userData);

  return (
    <PageLayout>
      <PageHeader title="Overview" actions={jwtToken ? <GlobalSearch jwtToken={jwtToken} /> : undefined} />
      {!jwtToken || !userData ? (
        <LoadingState message="Loading dashboard..." />
      ) : (
        <>
          <OrganisationActivity jwtToken={jwtToken} />
          <ToolCards jwtToken={jwtToken} />
          <RoundsTable jwtToken={jwtToken} />
        </>
      )}
    </PageLayout>
  );
};

export default Dashboard;
